import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import { useRef } from "react";

interface RestoreSessionDialogProps {
  isOpen: boolean;
  onHandleRestoreSession: (restoreSession: boolean) => void;
}

// Restore session if the user dismisses the dialog accidentally.
const RestoreSessionDialog = ({
  isOpen,
  onHandleRestoreSession,
}: RestoreSessionDialogProps) => {
  const initialFocusRef = useRef<HTMLButtonElement>(null);
  return (
    <Modal
      closeOnOverlayClick={false}
      closeOnEsc={false}
      isOpen={isOpen}
      onClose={() => onHandleRestoreSession(false)}
      initialFocusRef={initialFocusRef}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Restore session</ModalHeader>
        <ModalBody>
          An existing session has been found. Would you like to restore your
          existing session (restores students and audio data) or start a new
          session?
        </ModalBody>
        <ModalFooter>
          <HStack spacing={3}>
            <Button onClick={() => onHandleRestoreSession(false)}>
              New session
            </Button>
            <Button
              colorScheme="blue"
              onClick={() => onHandleRestoreSession(true)}
              ref={initialFocusRef}
            >
              Restore session
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default RestoreSessionDialog;
